<div *ngIf="isSaving" class="email-relay-spinner-block">
    <mat-progress-bar mode="indeterminate" [color]="'primary'"></mat-progress-bar>
</div>

<form name="formGroup" [formGroup]="formGroup" (ngSubmit)="onSave(formGroup?.controls?.inputField0?.value)">
    <div mat-dialog-content>

        <h2 class="input-field-dialog-title">{{injectedData?.dialogTitle}}</h2>

        <ng-container *ngIf="message">
            <p>{{message}}</p>
        </ng-container>

        <mat-form-field class="dialog-input-field" *ngFor="let inputField of injectedData.inputFields; let index = index">
            <mat-label>{{inputField?.label}}</mat-label>
            <input matInput
                   type="text"
                   formControlName="inputField{{index}}"
                   [placeholder]="inputField?.placeholder"
                   [disabled]="isSaving"
                   [required]="true"
            >
            <button *ngIf="inputField.copy" matSuffix mat-icon-button aria-label="Copy"
                    type="button"
                    class="ml-8 copy-btn"
                    ngxClipboard
                    [cbContent]="inputField.value"
                    (cbOnSuccess)="onCopyToClipboard()"
                    matTooltip="Copy to Clipboard"
            >
                <mat-icon>content_copy</mat-icon>
            </button>
        </mat-form-field>

        <mat-form-field class="dialog-input-field" *ngIf="injectedData?.parentOU">
            <mat-label>Parent organizational unit</mat-label>
            <input matInput
                   formControlName="parentOUField"
                   type="text"
                   [disabled]="true"
                   [required]="true"
            />
        </mat-form-field>

    </div>

    <p *ngIf="injectedData?.dialogTitle === 'Domain Verification Required'">If you encounter any issues, please contact <a href="mailto:support@gg4l.com">support@gg4l.com</a> or revisit this section to view the CNAME records again.</p>

    <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
        <button mat-button
                *ngIf="!!closeBtnName"
                type="button"
                (click)="onClose()"
                class="mr-8"
                tabindex="12"
                [disabled]="isSaving"
        >
            {{closeBtnName}}
        </button>

        <button mat-raised-button
                color="primary"
                type="submit"
                [disabled]="formGroup?.invalid || isSaving"
        >
            {{saveBtnName}}
        </button>

    </mat-dialog-actions>
</form>
